import { isEmpty } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';

import { MenuItem, SelectChangeEvent } from '@mui/material';

import Hljs from 'main/components/Hljs';
import Collapsible from 'pages/Bulletin/components/Collapsible';
import Select from 'pages/Bulletin/components/Select';

import useStyles from './styles';

import CopyButton from '../CopyButton';

interface Props {
    affected: Record<string, object | null | undefined>;
    className?: string;
}

const Affected: React.FC<Props> = ({ affected, className }) => {
    const { classes, cx } = useStyles();

    const options = useMemo(
        () =>
            Object.entries(affected ?? {})
                .filter(([_key, value]) => !isEmpty(value))
                .map(([key, _value]) => ({
                    label: key.toUpperCase(),
                    value: key
                })),
        [affected]
    );

    const [head] = options;
    const [value, setValue] = useState(head?.value);

    const handleChange = useCallback((event: SelectChangeEvent) => setValue(event.target.value), []);

    const stringified = useMemo(() => JSON.stringify(affected[value], null, 2), [affected, value]);

    if (isEmpty(options)) {
        return null;
    }

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.toolbar}>
                <Select
                    size="large"
                    inverted
                    value={value}
                    onChange={handleChange}
                    classes={{ root: classes.labelRoot, select: classes.labelSelect }}
                >
                    {options.map(({ label, value }, index) => (
                        <MenuItem key={index} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </Select>
                {stringified ? <CopyButton value={stringified} /> : null}
            </div>
            <Collapsible inverted maxSize={575}>
                <Hljs language={'json'} className={classes.code}>
                    {stringified}
                </Hljs>
            </Collapsible>
        </div>
    );
};

export default Affected;
